import React from 'react';
import clsx from 'clsx';

export const Card = ({ title, children, className = '' }) => {
  return (
    <div
      className={clsx(
        'rounded-2xl p-5 backdrop-blur-md bg-white/10 dark:bg-white/10 border border-white/20 dark:border-white/10 shadow-xl text-white',
        className
      )}
    >
      {title && (
        <h2 className="text-lg font-semibold mb-3 text-gray-800 dark:text-white">
          {title}
        </h2>
      )}
      <div>{children}</div>
    </div>
  );
};